import { Component } from 'react'
import PropTypes from 'prop-types'
import queryString from 'query-string'

import Email from 'components/authentication/form-fields/Email'
import SetPassword from 'components/authentication/form-fields/SetPassword'
import SAMLRequired from 'components/authentication/registration/new-user/SAMLRequired'
import authentication from 'api/authentication'
import { track, identify } from 'track'
import toast from 'lib/toast'
import { withAuthContext } from 'context/with-auth-context'
import agent from 'agent'
import SignedOutForm, {
  SignedOutFormContainer,
  UpperBackText
} from 'components/authentication/SignedOutForm'

const STAGE_FORM_DETAILS = {
  email: {
    title: 'Create Your Account'
  },
  password: {
    title: 'Set your password',
    back: true
  },
  saml: {
    title: 'SAML Required'
  }
}

const FORM_STAGES = {
  EMAIL: 'email',
  PASSWORD: 'password',
  SAML_REQUIRED: 'saml'
}

class NewUser extends Component {
  static propTypes = {
    location: PropTypes.object,
    history: PropTypes.object,
    signin: PropTypes.func,
    authState: PropTypes.object
  }

  static defaultProps = {
    signin: authentication.signin
  }

  constructor(props) {
    super()
    const { code, email, orgId, companyId } = queryString.parse(
      props.location.search
    )

    this.state = {
      email: email || '',
      password: '',
      confirmPassword: '',
      code,
      orgId: orgId || '',
      companyId: companyId || '',
      submitting: false,
      formStage: FORM_STAGES.EMAIL,
      fullName: '',
      privacyPolicyAccepted: false
    }
  }

  trackSubmission(email) {
    identify(email)
    track('RegistrationSubmission', {
      userId: email,
      role: 'user'
    })
  }

  handleChange = ({ target }) => {
    this.setState({ [target.name]: target.value })
  }

  handleBack = () => {
    this.setState({ formStage: FORM_STAGES.EMAIL })
  }

  submitDetails = async () => {
    const { companyId, code, email, password } = this.state
    const { authState } = this.props
    const role = 'USER'

    this.setState({ submitting: true })

    let session
    try {
      const res = await agent.post(`/companies/${companyId}/users`, {
        code,
        email,
        password,
        role,
        allow_us_storage: true
      })
      session = res.data

      if (session.result === 'SAML_REQUIRED') {
        this.setState({
          formStage: FORM_STAGES.SAML_REQUIRED,
          submitting: false,
          samlMessage: session.message
        })
        this.trackSubmission(email)
        return
      }

      this.trackSubmission(email)
      this.setState({ submitting: false })
      if (session) {
        await authState.startSession(session)

        toast({
          type: 'success',
          text: 'Account Created, Welcome to Gremlin'
        })

        this.props.history.push('/')
      }
    } catch (err) {
      console.error(err)

      toast({
        type: 'error',
        text:
          (err.response || {}).data ||
          'There was an issue, Please try again later'
      })
    }
  }

  handleSubmit = event => {
    event.preventDefault()
    switch (this.state.formStage) {
      case FORM_STAGES.EMAIL:
        return this.setState({ formStage: FORM_STAGES.PASSWORD })
      case FORM_STAGES.PASSWORD:
        return this.submitDetails()
    }
  }

  handleAcceptPrivacyPolicyChange = () => {
    this.setState({
      privacyPolicyAccepted: !this.state.privacyPolicyAccepted
    })
  }

  render() {
    const {
      formStage,
      email,
      password,
      confirmPassword,
      privacyPolicyAccepted,
      submitting,
      samlMessage
    } = this.state

    const { title, back } = STAGE_FORM_DETAILS[formStage]
    return (
      <SignedOutFormContainer>
        <UpperBackText onClick={back && this.handleBack}>Back</UpperBackText>
        <SignedOutForm
          handleBack={back && this.handleBack}
          title={title}
          onSubmit={this.handleSubmit}
        >
          {formStage === FORM_STAGES.EMAIL && (
            <Email email={email} inputIsDisabled={true} />
          )}
          {formStage === FORM_STAGES.PASSWORD && (
            <SetPassword
              confirmPassword={confirmPassword}
              handleAcceptPrivacyPolicyChange={
                this.handleAcceptPrivacyPolicyChange
              }
              handleChange={this.handleChange}
              isLoading={submitting}
              password={password}
              privacyPolicyAccepted={privacyPolicyAccepted}
            />
          )}
          {formStage === FORM_STAGES.SAML_REQUIRED && (
            <SAMLRequired
              message={samlMessage}
              samlUrl={authentication.generateSamlUrl({ email })}
            />
          )}
        </SignedOutForm>
      </SignedOutFormContainer>
    )
  }
}

export default withAuthContext(NewUser)
